import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react'; // Importa useRef e useMemo
import { Container, Tab, Tabs, Button, Spinner, Table, Modal, Form, Row, Col, Image, Alert } from 'react-bootstrap'; // Adicionado Row, Col, Image e Alert
import { useNavigate } from 'react-router-dom';
import { useUserContext } from '../UserContext';
import config from '../config'; 
import axios from 'axios';
import { useEntidadeContext } from '../EntidadeContext'; // Importar contexto da entidade
import CurrencyInput from 'react-currency-input-field';
import MaterialTab from '../components/estoque/MaterialTab'; // Importar o novo componente
import EstoqueItensTab from '../components/estoque/EstoqueItensTab'; // Importar o novo componente
import { useAlertModal } from '../AlertModalContext';
import logoImage from '../img/logo.png'; // Importa a imagem da logo
import { useAuthContext } from '../context/AuthContext'; // Importar para verificar assinatura


const Estoque = () => {
    const { currentUserRole, getPermittedInternalTabs, isLoadingAccessConfig, dynamicAccessConfig } = useUserContext(); // Obter estados do contexto
    const { currentEntidade, isLoadingEntidade } = useEntidadeContext(); // Usar contexto
    const [estoque, setEstoque] = useState([]);  // New state for stock data
    const { showAlertModal } = useAlertModal();

    const { authState } = useAuthContext(); // Obter o estado de autenticação
    const navigate = useNavigate(); // Para o botão de redirecionamento
    // Novos estados para o Modal de Ajuste de Estoque
    const [showAdjustModal, setShowAdjustModal] = useState(false);
    const [itemToAdjust, setItemToAdjust] = useState(null);
    const [adjustmentData, setAdjustmentData] = useState({
        quantidade: '',
        tipo_movimento: 'entrada_manual',
        justificativa: ''
    });
    const [isSavingAdjustment, setIsSavingAdjustment] = useState(false);

    // Novos estados para o Modal de Unificação de Materiais
    const [showMergeModal, setShowMergeModal] = useState(false);
    const [mainMaterialId, setMainMaterialId] = useState('');
    const [sourceMaterialId, setSourceMaterialId] = useState('');
    const [isMerging, setIsMerging] = useState(false);
    const [mergeMessage, setMergeMessage] = useState(null);

    // Novos estados para o Modal de Desvinculação (Inativação forçada)
    const [showUnlinkModal, setShowUnlinkModal] = useState(false);
    const [materialToUnlink, setMaterialToUnlink] = useState(null);
    const [isUnlinking, setIsUnlinking] = useState(false);

    // Novo estado para o filtro de materiais ativos/inativos
    const [mostrarInativos, setMostrarInativos] = useState(false);

    const [tiposMateriais, setTiposMateriais] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false); // Mantém para o modal de MaterialTab
    const [novoMaterial, setNovoMaterial] = useState({
      nome: '',
        descricao: '',
        tipo: '', // For tipo material nome
        fornecedor: '',
        lote: '',
        validade: '',
        fabricante: '',
        numero_serie: '',
        quantidade_adquirida: 0,
        valor: 0,
        valor_unidade: 0,
        unidade_medida: '', // For tipo material
        quantidade: 0,  // For estoque inicial
        estoque_minimo: 0,
        estoque_maximo: '',
    }); 

    // Obter abas permitidas para Estoque
    const permittedTabs = useMemo(() => {
        return getPermittedInternalTabs('estoque', currentUserRole);
      },
      [getPermittedInternalTabs, currentUserRole, isLoadingAccessConfig, dynamicAccessConfig]
    );
    // Define a aba ativa inicial para a primeira permitida, ou 'material' como fallback
    const [key, setKey] = useState(permittedTabs[0]?.key || 'material');

    // Ajusta a aba ativa se a atual não for permitida para a role (useEffect)
    useEffect(() => {
        if (permittedTabs.length > 0 && !isLoadingAccessConfig && !permittedTabs.some(tab => tab.key === key)) { // Garante que o loading terminou
            setKey(permittedTabs[0].key);
        }
    }, [key, permittedTabs, isLoadingAccessConfig]); // Ajustadas dependências

    const fetchData = useCallback(async () => {
        if (!currentEntidade?.id) return;
        setIsLoading(true);
        try {
            const statusFiltro = mostrarInativos ? 'inativo' : 'ativo';
            const [tiposResponse, estoqueResponse] = await Promise.all([
                axios.get(`/api/tipos_materiais?entidade_id=${currentEntidade.id}&status=${statusFiltro}`),
                axios.get(`/api/estoque?entidade_id=${currentEntidade.id}`)
            ]);
            setTiposMateriais(tiposResponse.data.tipos_materiais || []);
            setEstoque(estoqueResponse.data.estoque || []);
        } catch (error) {
            console.error('Erro ao buscar dados do estoque:', error);
        } finally {
            setIsLoading(false);
        }
    }, [currentEntidade, mostrarInativos]);

    
    useEffect(() => {
        // Este efeito agora é acionado sempre que a entidade muda ou o filtro 'mostrarInativos' é alterado (via dependência de fetchData).
        // A verificação garante que só buscamos os dados quando a entidade está carregada.
        if (currentEntidade?.id && !isLoadingEntidade) {
            fetchData();
        }
    }, [currentEntidade, isLoadingEntidade, fetchData]); // fetchData agora inclui a dependência 'mostrarInativos'

    
    // Helper function to find stock quantity for a given tipoMaterial
    const getQuantidadeEmEstoque = (tipoMaterialId) => {
        const estoqueItem = estoque.find(item => item.materiais_tipos_id === tipoMaterialId);
        return estoqueItem ? estoqueItem.quantidade_em_estoque : 0; // Return 0 if not found
    };

    // Filtra a lista de estoque para não mostrar itens que estão inativos E com estoque zerado.
    const estoqueFiltrado = useMemo(() => {
        if (!estoque) {
            return [];
        }
        return estoque.filter(item => {
            // Mantém o item se o tipo de material for ativo, OU se a quantidade em estoque for diferente de zero.
            // Oculta apenas se for inativo E zerado.

            if (item.tipo_material?.ativo == 0 && item.quantidade_em_estoque == 0) {
               return false;
            } else {
                return true;
            }
            
        }).sort((a, b) => {
            const nomeA = a.tipo_material?.nome || '';
            const nomeB = b.tipo_material?.nome || '';
            return nomeA.localeCompare(nomeB);
        });
    }, [estoque]);

    const handleOpenModal = () => setShowModal(true);

    const handleCloseModal = () => {
        setShowModal(false);
        setNovoMaterial({
          nome: '',
          descricao: '',
          tipo: '',
          fornecedor: '',
          lote: '',
          validade: '',
          fabricante: '',
          numero_serie: '',
          quantidade_adquirida: 0,
          valor: '', // Resetting to a number won't work with CurrencyInput. Use '0.00' or similar
          valor_unidade: 0,
          unidade_medida: '',
          quantidade: 0,
          estoque_minimo: 0,
          estoque_maximo: '',


      });
    };

    const handleChange = (event) => {
      const { name, value } = event.target;
      const parsedValue = name === 'valor' || name === 'quantidade_adquirida' || name === 'quantidade'
        ? parseFloat(value) || 0 // Garante que seja um número ou 0 se NaN
        : value;
      setNovoMaterial(prevState => {

          const newState = { ...prevState, [name]: parsedValue };

          if(name === 'valor' || name === 'quantidade_adquirida') { // only recalculate if valor or quantidade_adquirida changes
              if (newState.quantidade_adquirida > 0) {

                newState.valor_unidade = (parseFloat(newState.valor) / parseFloat(newState.quantidade_adquirida)).toFixed(2);
              } else {
                newState.valor_unidade = 0; // Or handle as appropriate (e.g., disable submit, show error message if quantidade_adquirida <= 0 when valor > 0)
              }
          }
          return newState;
      });
    };

    
    const handleSubmit = async (event) => {
      event.preventDefault();
      setIsLoading(true);
      if (!currentEntidade) return; // Segurança

  
      try {
        const data = {
          ...novoMaterial, 
          entidade_id: currentEntidade.id, // Adiciona o entidade_id do contexto
          quantidade_em_estoque: novoMaterial.quantidade_adquirida}; //Include quantidade_adquirida and valor_unidade
        const response = await axios.post(`/api/materiais/criar-com-tipo`, data); //Send to backend

        // // Make a single request to the criar-com-tipo route
        // const response = await axios.post(`/api/materiais/criar-com-tipo`, data);
        // // Handle the response (e.g., update state, display success message)
        // Atualiza a lista de tipos de materiais e estoque após a criação
        const [tiposResponse, estoqueResponse] = await Promise.all([
            axios.get(`/api/tipos_materiais?entidade_id=${currentEntidade.id}`),
            axios.get(`/api/estoque?entidade_id=${currentEntidade.id}`)
        ]);
        setTiposMateriais(tiposResponse.data.tipos_materiais);
        setEstoque(estoqueResponse.data.estoque);

        handleCloseModal();
      } catch (error) {
        console.error('Erro ao criar material e estoque:', error);
        if (error.response && error.response.data && error.response.data.errors) {
            // Exiba mensagens de erro de validação do backend
            console.error(error.response.data.errors); // Log the errors for debugging
    
            // Create an error message string to display to the user
            const errorMessages = Object.values(error.response.data.errors).flat().join('\n');
            alert(errorMessages);
    
        } else {
            alert('Ocorreu um erro ao criar o material e estoque.');
        }
    
      } finally {
        setIsLoading(false);
      }
    };

    // Handlers para o Modal de Ajuste de Estoque
    const handleOpenAdjustModal = (item) => {
        setItemToAdjust(item);
        setShowAdjustModal(true);
    };

    const handleCloseAdjustModal = () => {
        setShowAdjustModal(false);
        setItemToAdjust(null);
        setAdjustmentData({
            quantidade: '',
            tipo_movimento: 'entrada_manual',
            justificativa: ''
        });
    };

    const handleAdjustmentChange = (e) => {
        const { name, value } = e.target;
        setAdjustmentData(prev => ({ ...prev, [name]: value }));
    };

    const handleSaveAdjustment = async (e) => {
        e.preventDefault();
        if (!itemToAdjust || !adjustmentData.quantidade) {
            alert('A quantidade é obrigatória.');
            return;
        }

        // Converte a quantidade para um número positivo para garantir consistência.
        let quantidadeAjuste = Math.abs(parseFloat(adjustmentData.quantidade));

        // Se o movimento for de saída ou perda, transforma a quantidade em um número negativo.
        if (adjustmentData.tipo_movimento === 'saida_manual' || adjustmentData.tipo_movimento === 'perda') {
            quantidadeAjuste = -quantidadeAjuste;
        }

        setIsSavingAdjustment(true);
        try {
            const payload = {
                ...adjustmentData,
                entidade_id: currentEntidade.id,
                estoque_id: itemToAdjust.id,
                quantidade: quantidadeAjuste // Usa a quantidade ajustada (positiva ou negativa)
            };

            // O backend já está preparado para receber um valor positivo ou negativo.
            const response = await axios.post('/api/estoque/ajustar', payload);

            // Atualiza o estado local com o novo dado do estoque
            const updatedEstoqueItem = response.data.estoque;
            setEstoque(prevEstoque =>
                prevEstoque.map(item =>
                    item.id === updatedEstoqueItem.id ? updatedEstoqueItem : item
                )
            );
            handleCloseAdjustModal();
        } catch (error) {
            console.error("Erro ao ajustar estoque:", error);
            alert(`Erro ao ajustar estoque: ${error.response?.data?.message || 'Tente novamente.'}`);
        } finally {
            setIsSavingAdjustment(false);
        }
    };

    const handleMinimoChange = async (itemId, novoMinimo) => {
        const item = estoque.find(i => i.id === itemId);
        const novoMinimoNumerico = Number(novoMinimo);

        // Previne chamada de API se o valor não mudou ou é inválido
        if (!item || Number(item.estoque_minimo) === novoMinimoNumerico || isNaN(novoMinimoNumerico)) {
            return;
        }

        try {
            // Este endpoint precisa ser criado no backend (PATCH é ideal para atualizações parciais)
            const response = await axios.patch(`/api/estoque/${itemId}`, {
                estoque_minimo: novoMinimoNumerico
            });

            // Atualiza o estado local com o novo dado do estoque
            const updatedEstoqueItem = response.data.estoque;
            setEstoque(prevEstoque => prevEstoque.map(item => item.id === updatedEstoqueItem.id ? updatedEstoqueItem : item));
        } catch (error) {
            console.error("Erro ao atualizar estoque mínimo:", error);
            alert(`Erro ao atualizar estoque mínimo: ${error.response?.data?.message || 'Tente novamente.'}`);
            // Opcional: reverter a mudança na UI ou buscar os dados novamente para garantir consistência.
        }
    };

    const handleToggleStatus = async (tipoMaterialId) => {
        const action = mostrarInativos ? 'reativar' : 'inativar';
        const title = `Confirmar ${mostrarInativos ? 'Reativação' : 'Inativação'}`;
        const message = `Tem certeza que deseja ${action} este tipo de material?`;

        showAlertModal(
            title,
            message,
            'warning',
            async () => {
                setIsLoading(true);
                try {
                    await axios.patch(`/api/tipos_materiais/${tipoMaterialId}/toggle-status`);
                    const successMessage = `Material ${action === 'inativar' ? 'inativado' : 'reativado'} com sucesso.`;
                    showAlertModal('Sucesso', successMessage, 'success');
                    await fetchData(); // Recarrega a lista para refletir a mudança
                } catch (error) {
                    // Verifica se é erro de conflito (serviços vinculados) ao tentar inativar
                    if (action === 'inativar' && error.response && error.response.status === 409) {
                        const material = tiposMateriais.find(t => t.id === tipoMaterialId);
                        const servicosVinculados = error.response.data.servicos || [];
                        setMaterialToUnlink({ 
                            ...(material || { id: tipoMaterialId, nome: 'Material' }), 
                            servicosVinculados 
                        });
                        setShowUnlinkModal(true);
                    } else {
                        showAlertModal(
                            'Erro',
                            error.response?.data?.message || 'Não foi possível alterar o status do material.',
                            'danger'
                        );
                    }
                } finally {
                    setIsLoading(false);
                }
            },
            true // isConfirmation
        );
    };

    const handleCloseUnlinkModal = () => {
        setShowUnlinkModal(false);
        setMaterialToUnlink(null);
    };

    const handleConfirmUnlink = async () => {
        if (!materialToUnlink) return;
        setIsUnlinking(true);
        try {
            // Envia force_unlink: true para forçar a desvinculação e inativação
            await axios.patch(`/api/tipos_materiais/${materialToUnlink.id}/toggle-status`, { force_unlink: true });
            showAlertModal('Sucesso', 'Material desvinculado dos serviços e inativado com sucesso!', 'success');
            fetchData();
            handleCloseUnlinkModal();
        } catch (error) {
            showAlertModal('Erro', error.response?.data?.message || 'Erro ao inativar material.', 'danger');
        } finally {
            setIsUnlinking(false);
        }
    };

    // Handlers para o Modal de Unificação
    const handleOpenMergeModal = () => {
        setMergeMessage(null);
        setMainMaterialId('');
        setSourceMaterialId('');
        setShowMergeModal(true);
    };

    const handleCloseMergeModal = () => setShowMergeModal(false);

    const handleMergeSubmit = async () => {
        if (!mainMaterialId || !sourceMaterialId) {
            setMergeMessage({ type: 'danger', text: 'Por favor, selecione ambos os materiais.' });
            return;
        }
        if (mainMaterialId === sourceMaterialId) {
            setMergeMessage({ type: 'danger', text: 'Os materiais devem ser diferentes.' });
            return;
        }

        setIsMerging(true);
        setMergeMessage(null);

        try {
            await axios.post('/api/tipos_materiais/merge', {
                entidade_id: currentEntidade.id,
                main_tipo_id: mainMaterialId,
                source_tipo_id: sourceMaterialId,
            });
            setMergeMessage({ type: 'success', text: 'Materiais unificados com sucesso! A lista será atualizada.' });
            
            // Aguarda a atualização dos dados e depois fecha o modal
            await fetchData();
            setTimeout(() => handleCloseMergeModal(), 2000);

        } catch (error) {
            setMergeMessage({ type: 'danger', text: error.response?.data?.message || 'Erro ao unificar materiais.' });
        } finally {
            setIsMerging(false);
        }
    };

    // --- INÍCIO DA VALIDAÇÃO DE ACESSO AO CONTEÚDO ---
    const isAccessBlocked = useMemo(() => {
        const subscription = authState.subscription;

        // Se a assinatura existe, não é vitalícia e não está ativa/em teste
        if (subscription && !subscription.plan?.is_lifetime ) {
            const expirationDate = new Date(subscription.current_period_ends_at + 'T00:00:00');
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            if (today > expirationDate) {
                const diffTime = today.getTime() - expirationDate.getTime();
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                // Bloqueia o acesso se expirou há mais de 10 dias
                if (diffDays > 10) {
                    return true;
                }
            }
        }
        // Se nenhuma condição de bloqueio for atendida, permite o acesso.
        return false;
    }, [authState.subscription]);

    const BlockedContent = () => (
        <Alert variant="danger" className="text-center m-4">
            <Alert.Heading>Acesso ao Estoque Restrito</Alert.Heading>
            <p>Seu plano expirou há mais de 10 dias. Para gerenciar seu estoque, por favor, regularize sua assinatura.</p>
            <Button variant="danger" onClick={() => navigate('/pricing')}>Ver Planos e Regularizar</Button>
        </Alert>
    );

    return (
        <div style={{ border: '1px solid gray', backgroundColor: '#f5f5f5' }}>
            <div className="header" style={{ minHeight: '80px' }}>
                <Row className="p-1 align-items-center" style={{ minHeight: 'inherit' }}>
                    <Col xs={12} md={6} style={{ minHeight: '60px' }}>
                        <div className="d-flex align-items-center justify-content-start h-100">
                            <Image src={logoImage} alt="Logo Clínica" style={{ maxHeight: '60px', marginLeft: '12px' }} />
                            <h3 style={{ marginLeft: '15px', marginBottom: '0' }}>Gestão de Estoque</h3>
                        </div>
                    </Col>
                    <Col xs={12} md={6} className="text-end">
                        {/* Espaço para futuros botões de ação no cabeçalho, se necessário */}
                    </Col>
                </Row>
            </div>
            <div className="body p-3">
                {isAccessBlocked ? (
                    <BlockedContent />
                ) : (
                    <Tabs activeKey={key} onSelect={(k) => setKey(k)} className="mb-3">
                        {/* Renderiza as abas permitidas dinamicamente com base nas permissões */}
                        {getPermittedInternalTabs('estoque', currentUserRole).map(tab => (
                            <Tab
                                key={tab.key}
                                eventKey={tab.key}
                                title={tab.title}
                            >
                            {/* Conteúdo da aba 'Material' */}
                            {tab.key === 'material' && ( // Conditional rendering for the 'material' tab content
                                <MaterialTab
                                    tiposMateriais={tiposMateriais}
                                    isLoading={isLoading}
                                    showModal={showModal}
                                    handleCloseModal={handleCloseModal}
                                    handleOpenModal={handleOpenModal}
                                    handleOpenMergeModal={handleOpenMergeModal} // Passa a nova função
                                    mostrarInativos={mostrarInativos}
                                    setMostrarInativos={setMostrarInativos}
                                    handleToggleStatus={handleToggleStatus} // Passa a função de inativar
                                    novoMaterial={novoMaterial}
                                    handleChange={handleChange}
                                    handleSubmit={handleSubmit}
                                    getQuantidadeEmEstoque={getQuantidadeEmEstoque}
                                />
                            )}

                            {/* Conteúdo da aba 'Estoque' */}
                            {tab.key === 'estoque' && (
                                <EstoqueItensTab 
                                    estoque={estoqueFiltrado}
                                    handleOpenAdjustModal={handleOpenAdjustModal}
                                    handleMinimoChange={handleMinimoChange}
                                />
                            )}
                            </Tab>
                        ))}
                    </Tabs>
                )}
            </div>

            {/* Modal de Ajuste de Estoque */}
            <Modal show={showAdjustModal} onHide={handleCloseAdjustModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Ajustar Estoque: {itemToAdjust?.tipo_material?.nome}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSaveAdjustment}>
                        <Form.Group className="mb-3" controlId="ajusteTipo">
                            <Form.Label>Tipo de Movimento</Form.Label>
                            <Form.Select name="tipo_movimento" value={adjustmentData.tipo_movimento} onChange={handleAdjustmentChange}>
                                <option value="entrada_manual">Entrada (Manual)</option>
                                <option value="saida_manual">Saída (Manual)</option>
                                <option value="perda">Perda</option>
                                <option value="ajuste_contagem">Ajuste (Contagem)</option>
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="ajusteQuantidade">
                            <Form.Label>Quantidade</Form.Label>
                            <Form.Control 
                                type="number" 
                                name="quantidade" 
                                value={adjustmentData.quantidade} 
                                onChange={handleAdjustmentChange} 
                                required 
                                placeholder="Ex: 10" 
                                min="0" // Impede a inserção de números negativos pelo navegador
                            />
                            <Form.Text muted>
                                A quantidade será somada (Entrada/Ajuste) ou subtraída (Saída/Perda) do estoque.
                            </Form.Text>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="ajusteJustificativa">
                            <Form.Label>Justificativa</Form.Label>
                            <Form.Control as="textarea" rows={3} name="justificativa" value={adjustmentData.justificativa} onChange={handleAdjustmentChange} placeholder="Ex: Compra de novo lote, quebra de material, etc." />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseAdjustModal} disabled={isSavingAdjustment}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={handleSaveAdjustment} disabled={isSavingAdjustment}>
                        {isSavingAdjustment ? <Spinner as="span" size="sm" /> : 'Salvar Ajuste'}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de Unificação de Materiais */}
            <Modal show={showMergeModal} onHide={handleCloseMergeModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Unificar Tipos de Materiais</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {mergeMessage && <Alert variant={mergeMessage.type}>{mergeMessage.text}</Alert>}
                    <p className="text-muted">Esta ação irá transferir todos os lotes e o estoque de um material para outro, e depois excluirá o material de origem. Esta ação não pode ser desfeita.</p>
                    <Form>
                        <Form.Group className="mb-3" controlId="mainMaterialSelect">
                            <Form.Label><strong>Material Principal (Manter)</strong></Form.Label>
                            <Form.Select value={mainMaterialId} onChange={(e) => setMainMaterialId(e.target.value)}>
                                <option value="">Selecione o material que permanecerá...</option>
                                {tiposMateriais.map(tipo => (
                                    <option key={tipo.id} value={tipo.id}>{tipo.nome}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="sourceMaterialSelect">
                            <Form.Label><strong>Material a ser Unificado (Excluir)</strong></Form.Label>
                            <Form.Select value={sourceMaterialId} onChange={(e) => setSourceMaterialId(e.target.value)} disabled={!mainMaterialId}>
                                <option value="">Selecione o material a ser absorvido...</option>
                                {tiposMateriais
                                    .filter(tipo => tipo.id !== parseInt(mainMaterialId)) // Filtra para não mostrar o principal
                                    .map(tipo => (
                                        <option key={tipo.id} value={tipo.id}>{tipo.nome}</option>
                                    ))
                                }
                            </Form.Select>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseMergeModal} disabled={isMerging}>
                        Cancelar
                    </Button>
                    <Button variant="warning" onClick={handleMergeSubmit} disabled={isMerging || !mainMaterialId || !sourceMaterialId}>
                        {isMerging ? (
                            <><Spinner as="span" animation="border" size="sm" /> Unificando...</>
                        ) : 'Confirmar Unificação'}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de Confirmação de Desvinculação e Inativação */}
            <Modal show={showUnlinkModal} onHide={handleCloseUnlinkModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Atenção: Serviços Vinculados</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>O material <strong>{materialToUnlink?.nome}</strong> está vinculado aos seguintes serviços ativos:</p>
                    {materialToUnlink?.servicosVinculados && materialToUnlink.servicosVinculados.length > 0 ? (
                        <ul>
                            {materialToUnlink.servicosVinculados.map((servico, index) => (
                                <li key={index}>{servico.nome || servico}</li>
                            ))}
                        </ul>
                    ) : (
                        <p className="text-muted"><em>(Lista de serviços não disponível)</em></p>
                    )}
                    <p>Deseja remover este material desses serviços e inativá-lo?</p>
                    <Alert variant="warning">
                        Esta ação removerá o material da composição de custos dos serviços afetados.
                    </Alert>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseUnlinkModal} disabled={isUnlinking}>
                        Não
                    </Button>
                    <Button variant="danger" onClick={handleConfirmUnlink} disabled={isUnlinking}>
                        {isUnlinking ? <Spinner as="span" size="sm" animation="border" /> : 'Sim, Desvincular e Inativar'}
                    </Button>
                </Modal.Footer>
            </Modal>

        </div>
    );
};

export default Estoque;
